export default [{
    path: '/data/recommendation-business/:id',
    name: 'Recommendation List',
    component: () => import('@/views/admin/recommendation-business/Index.vue'),
    meta: {
      rule: 'editor',
      pageTitle: 'Recommendation Business',
      breadcrumb: [{
          title: 'Home',
          url: '/'
        },
        {
          title: 'Data'
        },
        {
          title: 'Recommendation Business',
          active: true
        },
      ],
    }
  }
]
